import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, Button } from "semantic-ui-react";
import Sidebar from "../../app/common/util/Sidebar";
import { connect } from "react-redux";
import NavBar from "../nav/NavBar/NavBar";
import OrderForm from "./OrderForm";
import { fetchFormData } from "./orderActions";
import { getOrderDetailsForForm } from "../home/homeActions";
import SimplePageLoader from "../../app/common/util/SimplePageLoader";
import { doesFormDataExist } from "./formUtils";
import { isEmpty } from "../../app/common/util/genericUtils";
import { Row, Col } from "antd";
import OrderMetaSummaryCard from "../home/orderDetails/OrderMetaSummaryCard";

class OrderValidationPage extends Component {
  state = {};
  componentWillMount() {
    this.ensureOrderDetailsLoaded();
  }

  componentDidUpdate(prevProps) {
    const prevId =
      prevProps.match && prevProps.match.params && prevProps.match.params.id;
    const nextId =
      this.props.match && this.props.match.params && this.props.match.params.id;
    if (prevId !== nextId) {
      this.ensureOrderDetailsLoaded();
    }
  }

  ensureOrderDetailsLoaded = () => {
    const {
      match: { params },
      orderDetails,
      getOrderDetailsForForm,
    } = this.props;
    const dataFlag = doesFormDataExist();
    dataFlag && this.props.fetchFormData();
    const detailsId = orderDetails && orderDetails.id;
    if (isEmpty(orderDetails) || String(detailsId) !== String(params.id)) {
      getOrderDetailsForForm(params.id);
    }
  };
  render() {
    const { orderDetails, loadingFormData, loadingOrderData } = this.props;
    if (loadingFormData || loadingOrderData || isEmpty(orderDetails)) {
      return <SimplePageLoader label="Loading order…" />;
    }

    return (
      <div className="order-form-page">
        <NavBar />
        <Sidebar />
        <div className="order-form-page-header">
          <Row gutter={16} type="flex" align="top">
            <Col xs={24} sm={12} md={12} lg={12}>
              <Button
                as={Link}
                to="/"
                icon
                labelPosition="left"
                className="order-form-back-btn"
              >
                <Icon name="left arrow" />
                Back to Orders
              </Button>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              className="order-form-meta-col"
            >
              <OrderMetaSummaryCard
                source={orderDetails.source}
                author={orderDetails.author}
                authorisedBy={orderDetails.authorised_by}
              />
            </Col>
          </Row>
        </div>
        <OrderForm
          initialValues={orderDetails}
          type="validate"
          labelInValue={true}
        />
      </div>
    );
  }
}
const actions = {
  fetchFormData,
  getOrderDetailsForForm,
};
const mapStateToProps = (state) => ({
  loadingFormData: state.orderForm.loadingFormData,
  loadingOrderData: state.home.loadingOrderData,
  orderDetails: state.home.orderDetails,
});

export default connect(
  mapStateToProps,
  actions
)(OrderValidationPage);
